import { ChevronLeft, ChevronRight } from 'lucide-react';
import { breadcrumbFor } from '@/lib/navTree';
import { canGoBackInApp, replaceNextNavigation } from '@/lib/useSectionHistory';

// "‹ Back" (previous screen) + trail (Home › Module › Section). Module name returns to its main page.
export default function SectionTrail({ activeSection, onNavigate, fallbackLabel }) {
  const crumbs = breadcrumbFor(activeSection, fallbackLabel);
  const back = () => {
    if (canGoBackInApp()) { window.history.back(); return; }
    replaceNextNavigation();
    onNavigate(crumbs.length > 2 ? crumbs[crumbs.length - 2].section : 'home');
  };
  return (
    <div className="flex items-center gap-1 min-w-0" data-testid="section-trail">
      <button type="button" onClick={back} className="flex items-center gap-0.5 shrink-0 rounded-md px-2 py-1.5 text-sm font-medium hover:bg-muted transition-colors" data-testid="trail-back-btn">
        <ChevronLeft className="h-4 w-4" />Back
      </button>
      <span className="h-4 w-px bg-border mx-1 shrink-0" />
      <nav aria-label="Breadcrumb" className="flex items-center gap-0.5 min-w-0 text-xs text-muted-foreground">
        {crumbs.map((c, i) => {
          const last = i === crumbs.length - 1;
          return (
            <span key={c.section} className={`flex items-center gap-0.5 ${last ? 'min-w-0' : 'shrink-0'} ${i === 0 && crumbs.length > 2 ? 'hidden sm:flex' : ''}`}>
              {i > 0 && <ChevronRight className={`h-3 w-3 shrink-0 ${i === 1 && crumbs.length > 2 ? 'hidden sm:block' : ''}`} />}
              {last ? (
                <span className="font-medium text-foreground truncate" aria-current="page" data-testid="trail-current">{c.label}</span>
              ) : (
                <button type="button" onClick={() => onNavigate(c.section)} className="hover:text-foreground hover:underline underline-offset-2 whitespace-nowrap" data-testid={`trail-link-${c.section}`}>{c.label}</button>
              )}
            </span>
          );
        })}
      </nav>
    </div>
  );
}
